import Chapter from './Chapter';

import { isNumber } from '../../util/numbers';

export default class ChapterBreak {
  _frameStart;
  _nextChapter;
  _nextChapterIndex;
  _nextDuration;
  _previousChapter;
  _previousChapterIndex;
  _previousDuration;

  constructor(frameStart, previousChapter, nextChapter) {
    if (Chapter.isChapter(previousChapter)) {
      this._previousChapter = previousChapter;
      this._previousDuration = previousChapter.duration;
      this._previousChapterIndex = previousChapter.index;
    }

    if (Chapter.isChapter(nextChapter)) {
      this._nextChapter = nextChapter;
      this._nextChapterIndex = nextChapter.index;
      this._nextDuration = nextChapter.duration;
    }

    if (isNumber(frameStart)) {
      this._frameStart = frameStart;
    }
  }

  get chapterBreakIndex() {
    return this._nextChapter.index;
  }

  get chapterBreakNumber() {
    return this._nextChapter.index + 1;
  }

  get frameStart() {
    return this._frameStart;
  }

  get nextChapter() {
    return this._nextChapter;
  }

  get nextChapterIndex() {
    return this._nextChapterIndex;
  }

  get nextDuration() {
    return this._nextDuration;
  }

  get previousChapter() {
    return this._previousChapter;
  }

  get previousChapterIndex() {
    return this._previousChapterIndex;
  }

  get previousDuration() {
    return this._previousDuration;
  }

  /**
   * Checks if object is an instance of ChapterBreak
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isChapterBreak(inputObject) {
    return inputObject instanceof ChapterBreak;
  }
}
